import PRIVILEGES from './privileges';

const ROLES = {
  1: {
    name: 'customer',
    defaultStateName: 'home.dashboard',
    privileges:[]
  },
  2: {
    name: 'admin',
    defaultStateName: 'home.edit',
    privileges:[
      PRIVILEGES.TOOLS_TRIGGER_ORCHESTRATION,
      PRIVILEGES.TOOLS_OVERWRITE_SOURCE_ID,
      PRIVILEGES.TOOLS_RESET_BATCH,
      PRIVILEGES.TOOLS_PRODUCT_ASSIGNMENT_REPORT,
      PRIVILEGES.TOOLS_PURCHASING_ACCOUNTS,
      PRIVILEGES.TOOLS_ADMIN_PERMISSIONS,
      PRIVILEGES.TOOLS_SFTP_BATCH_TRIGGER,
    ]
  },
  4: {
    name: 'supportAdmin',
    defaultStateName: 'home.edit',
    privileges:[
      PRIVILEGES.TOOLS_REMOVE_MAPPINGS,
      PRIVILEGES.TOOLS_TRIGGER_ORCHESTRATION,
      PRIVILEGES.TOOLS_MAP_COURSES,
      PRIVILEGES.TOOLS_CREATE_ONE_ROSTER,
      PRIVILEGES.TOOLS_OVERWRITE_SOURCE_ID,
      PRIVILEGES.TOOLS_RESET_BATCH,
      PRIVILEGES.TOOLS_PRODUCT_ASSIGNMENT_REPORT,
      PRIVILEGES.TOOLS_DELETE_ENTITY,
      PRIVILEGES.TOOLS_PURCHASING_ACCOUNTS,
      PRIVILEGES.TOOLS_ADMIN_PERMISSIONS,
      PRIVILEGES.TOOLS_SFTP_BATCH_TRIGGER,
      PRIVILEGES.TOOLS_CANCEL_WORKFLOWS,
    ]
  },
  42: {
    name: 'superAdmin',
    defaultStateName: 'home.create',
    tabName: 'createAlert',
    privileges:[
      PRIVILEGES.TOOLS_REMOVE_MAPPINGS,
      PRIVILEGES.TOOLS_TRIGGER_ORCHESTRATION,
      PRIVILEGES.TOOLS_MAP_COURSES,
      PRIVILEGES.TOOLS_RESET_CUSTOMER,
      PRIVILEGES.TOOLS_CREATE_ONE_ROSTER,
      PRIVILEGES.TOOLS_OVERWRITE_SOURCE_ID,
      PRIVILEGES.TOOLS_RESET_BATCH,
      PRIVILEGES.TOOLS_PRODUCT_ASSIGNMENT_REPORT,
      PRIVILEGES.TOOLS_PAUSE_UNPAUSE_SERVICE,
      PRIVILEGES.TOOLS_MANAGE_DEAD_QUEUES,
      PRIVILEGES.TOOLS_DELETE_ENTITY,
      PRIVILEGES.TOOLS_PURCHASING_ACCOUNTS,
      PRIVILEGES.TOOLS_CANCEL_WORKFLOWS,
      PRIVILEGES.TOOLS_ADMIN_PERMISSIONS,
      PRIVILEGES.TOOLS_SFTP_BATCH_TRIGGER,
      PRIVILEGES.TOOLS_MANAGE_CLEVER_CREDENTIALS,
      PRIVILEGES.TOOLS_TRIGGER_SUBGROUP_ORCHESTRATION,
      PRIVILEGES.TOOLS_RESET_SUBGROUP_DATA,
    ]
  },
  CUSTOMER_ROLE: 1,
  MHE_ADMIN_ROLE: 2,
  SUPPORT_ADMIN: 4,
  SUPER_ADMIN: 42
};

export default ROLES;



// WEBPACK FOOTER //
// ./app/models/roles.js